export const hotTopics = [
  { id: "t001", title: "某顶流男星恋情曝光", heat: 98, trend: "up" },
  { id: "t002", title: "千万网红直播数据造假", heat: 95, trend: "up" },
  { id: "t003", title: "选秀节目黑幕实锤", heat: 92, trend: "stable" },
  { id: "t004", title: "知名导演潜规则丑闻", heat: 89, trend: "up" },
  { id: "t005", title: "大V人设崩塌学历造假", heat: 86, trend: "down" },
  { id: "t006", title: "地产富豪婚内出轨", heat: 84, trend: "stable" },
  { id: "t007", title: "女星隐婚生子曝光", heat: 81, trend: "up" },
  { id: "t008", title: "流量小生演技翻车", heat: 78, trend: "down" },
];